import React from "react";

import styles from "../../style/components/LoadingSpinner.module.scss";

export const LoadingSpinner = () => <div className={styles["loading-spinner"]} />;
